module.exports = __webpack_public_path__ + "static/dragon-difference-9746c2c0776b97ba8f9692f99136c0b3.png";